export default __webpack_public_path__ + "static/center-jp-7eccc95f26b4bf186b849d1082c3e611.webp";